import { PartnerIdTokenHelper } from 'legacy/lut/classes/helpers/partner360/getPartnerIdFromToken'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { getUrlWithParams } from 'core-components/helpers/url'
import { selectCurrentSitePageId } from 'core-components/sitebuilder/store/selectors/selectCurrentSitePageId'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { getPartnerBySigner } from './CommitmentHelper'

export const usePartnerId = (
  widgetParams: IObjectAny,
  pid?: string,
  redirectToPartner: boolean = false
) => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector(selectUser)
  const currentSitePageId = useSelector(selectCurrentSitePageId)

  const { isPartnerUser } = useUserRoles()
  const isP360Page = useMemo(() => {
    return currentSitePageId === 'p360'
  }, [currentSitePageId])

  const isGP360Page = useMemo(() => {
    return currentSitePageId === 'jbl-hpscoutso-global'
  }, [currentSitePageId])

  const partnerId = useMemo(() => {
    if (isGP360Page) {
      return pid
    }

    const partnerProId = PartnerIdTokenHelper.getPartnerId()

    if (isPartnerUser && isP360Page) {
      const partnerId = pid ? pid : widgetParams.PartnerProId
      const userPartnerId = partnerProId ? partnerProId : ''

      return partnerId ? partnerId : userPartnerId
    }

    return pid ? pid : widgetParams.PartnerProId
  }, [widgetParams.PartnerProId, pid, isPartnerUser, isP360Page, isGP360Page])

  useEffect(() => {
    if (isPartnerUser && isP360Page) {
      if (redirectToPartner) {
        if (!location.pathname.includes('pid')) {
          const partnerProId = PartnerIdTokenHelper.getPartnerId()
          getPartnerBySigner(user.email).then(({ partnerId, programType }) => {
            if (partnerId && programType) {
              const url = getUrlWithParams({
                pid: partnerId,
                ptype: programType,
                'jbp-tab': 7,
              })
              navigate(url)
            } else if (partnerProId) {
              navigate(getUrlWithParams({ pid: partnerProId }))
            }
          })
        }
      }
    }
  }, [isPartnerUser, isP360Page, redirectToPartner, user.email, location.pathname, navigate])

  return partnerId
}
